// Core Imports
import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
import NoteEntity from 'granite-admin/common/entities/note';
async function getNotes(params, signal) {
  const payload = {
    params,
    signal
  };
  try {
    const {
      data
    } = await GraniteAPIClient().get('/notes/', payload);
    const notes = data ? data.results.map(item => new NoteEntity(item)) : [];
    return {
      notes,
      nextPage: data.next_page,
      count: data.count
    };
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function createNote({
  organisation,
  ...values
}) {
  const payload = {
    ...values
  };
  let headers = {};
  if (organisation) headers.organisation = organisation;
  try {
    const {
      data
    } = await GraniteAPIClient(undefined, headers).post('/notes/', payload);
    return data;
  } catch (error) {
    throw error;
  }
}
export default {
  getNotes,
  createNote
};